<app-shipment-system-simplenav></app-shipment-system-simplenav>

<div class="container">

    <div class="card  mt-3">
        <div class="card-body">

            <h3>Ruter</h3>

            <p *ngIf="!shipmentRoutes" class="text-center  text-muted  mt-2">Indlæser...</p>

            <div *ngIf="shipmentRoutes">
                <p class="mb-3 text-end">
                    <a href="javascript:" (click)="add()">Tilføj rute</a>
                </p>

                <table class="table  table-bordered  table-sm  table-xs">
                    <thead class="bg-secondary text-white">
                    <tr>
                        <th>Rute Navn</th>
                        <th>Afdeling</th>
                        <th>Rute</th>
                        <th>Tur</th>
                        <th>Sort</th>
                        <th>Global</th>
                        <th>Chauffør</th>
                        <th style="width: 50px;"></th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr *ngFor="let shipmentRoute of shipmentRoutes">
                        <td><a routerLink="/shipment-routes/{{ shipmentRoute.id }}">{{ shipmentRoute.name }}</a></td>
                        <td>{{shipmentRoute.branch}}</td>
                        <td>{{shipmentRoute.driver}}</td>
                        <td>{{shipmentRoute.trip}}</td>
                        <td>{{shipmentRoute.sort}}</td>
                        <td>{{shipmentRoute.is_global?'Global':'-'}}</td>
                        <td>

                            <a *ngIf="shipmentRoute?.shipment_driver"
                               routerLink="/shipment-drivers/{{ shipmentRoute?.shipment_driver?.id }}">{{ shipmentRoute?.shipment_driver?.name }}</a>
                        </td>

                        <td class="text-end">
                            <!--                        <a href="javascript:" (click)="delete(shipmentRoute)">Slet</a>&nbsp;-->
                            <a routerLink="/shipment-routes/{{ shipmentRoute.id }}">Ret</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
